import React, { useEffect, useState, useCallback } from "react";
import { Survey } from "survey-react-ui";
import { submitFormAPI, getFormForJSONProjectAPI } from "views/APIs/APIUtility";
import { useParams } from "react-router-dom";
import PublicFormError from "./PublicFormError";
import Footer from "components/Footer/Footer";
import { AppBar, Avatar, Box, Container, Divider, Toolbar, Typography } from "@material-ui/core";
import "survey-core/survey-core.css";
// 2) Your brand overrides (the file you pasted)
import "./qu-brand.css";

const PublishedForm = () => {
    const { formID } = useParams();
    const [json, setJson] = useState({});
    const [error, setError] = useState(null);

    const fetchForm = useCallback(async () => {
        if (!formID) return;
        setError(null);
        const fd = new FormData();
        fd.append("json_project_id", formID);
        const response = await getFormForJSONProjectAPI(fd);
        if (response && response.error) {
            setError(response.error);
            return;
        }
        setJson(response || {});
    }, [formID]);

    useEffect(() => {
        fetchForm();
    }, [fetchForm]);

    const handleComplete = async (survey /* SurveyModel */) => {
        try {
            const answers = survey.data;
            const schema = survey.toJSON();

            const fd = new FormData();
            fd.append("json_project_id", formID);
            fd.append("form_data", JSON.stringify(answers));
            fd.append("survey_json", JSON.stringify(schema));

            await submitFormAPI(fd);
        } catch (error) {
            console.error(error);
        }
    };



    const images = require.context("assets/img/create_cards_16_9", true);
    const qcreateLogo = images("./qcreate.png")
    const quantuniversityLogoPath = "https://quantuniversity.com/assets/img/logo5.jpg";

    return (
        <Box>

            <AppBar position="static" color="inherit" elevation={0}>
                <Toolbar style={{ display: "flex", justifyContent: "space-between", marginLeft: "20vw", marginRight: "20vw" }}>
                    {/* Left: QCreate logo with link */}
                    <a href="https://qcreate.qusandbox.com" target="_blank" rel="noopener noreferrer">
                        <img
                            alt="QCreate"
                            src={qcreateLogo}
                            style={{ height: "100px", padding: "10px", borderRadius: 0 }}
                        />
                    </a>

                    {/* Right: Powered by QuantUniversity */}
                    <Box style={{ display: "flex", alignItems: "center", gap: 1, marginLeft: "auto" }}>
                        <Typography variant="h6" style={{ color: "#2e2e30", textTransform: "none" }}>Powered by:&nbsp;</Typography>
                        <Typography variant="h6" style={{ display: "flex", alignItems: "center", gap: 1, color: "#2e2e30", textTransform: "none" }}>
                            <a href="https://quantuniversity.com" target="_blank" rel="noopener noreferrer">
                                <Typography variant="h6" style={{ color: "#20677b", fontWeight: "bold" }}> QuantUniversity</Typography>
                            </a>
                        </Typography>
                    </Box>
                </Toolbar>
                <Divider />
            </AppBar>

            <Box style={{ display: "flex", flexDirection: "column", minHeight: "90vh", width: "100%" }}>
                {/* Main content */}
                <Box component="main" flexGrow={1} py={4}>
                    <Container maxWidth="md">{error ? (
                        <PublicFormError error={error} />
                    ) : (
                        <div className="qu-theme">
                            <Survey json={json} onComplete={handleComplete} />
                        </div>
                    )}
                    </Container>
                </Box>
            </Box>
            <Footer />
        </Box>
    );
};

export default PublishedForm;
